import { Nemesis } from '../../../../aer-types/types'

export const nemeses: Nemesis[] = [
  {
    expansion: 'NA',
    name: 'Władczyni Wylęgu',
    id: 'Maggoth',
    health: 45,
    difficulty: 3,
    expeditionRating: 1,
    additionalInfo: '',
  },
  {
    expansion: 'NA',
    name: 'Arachnos',
    id: 'Arachnos',
    health: 70,
    difficulty: 4,
    expeditionRating: 2,
    additionalInfo: '',
  },
  {
    expansion: 'NA',
    name: 'Wędrowiec Wszechczasu',
    id: 'AgelessWalker',
    health: 80,
    difficulty: 5,
    expeditionRating: 3,
    additionalInfo: '',
  },
  {
    expansion: 'NA',
    name: 'Fenrix',
    id: 'Fenrix',
    health: 60,
    difficulty: 7,
    expeditionRating: 4,
    additionalInfo: '',
  },
]
